import { useQuery } from '@tanstack/react-query'

import { get } from '../api'
import { User } from '../store/userslice'
import { useEffect } from 'react'
import { showToast } from '../utils/toast'
import { t } from '@lingui/core/macro'
import { useAccount } from './useAccount'

interface UserResponse {
  user: User
  topSkins: any[]
}

export const useUserBasicInfo = () => {
  const { isLogin } = useAccount()
  const fetchUserInfo = async () => {
    try {
      const response = await get(`/v1/skinsyard/facade/user/info`)
      return response
    } catch (err) {
      console.error(err)
      throw err
    }
  }
  const { data, isFetching, error, refetch } = useQuery<{ data: User }>({
    queryKey: ['userBasicInfo', isLogin],
    queryFn: fetchUserInfo,
    enabled: !!isLogin,
    refetchInterval: false,
  })

  useEffect(() => {
    if (error) {
      showToast.error(t`Cannot reach the server.`)
      console.error(error)
    }
  }, [error])

  return {
    userInfo: data?.data,
    loading: isFetching,
    error,
    refetch,
  }
}

export const useUserInfo = (queryUserId?: string) => {
  const targetUserId = queryUserId
  const fetchUserInfo = async () => {
    try {
      const response = await get(`/v1/skinsyard/facade/user/profile/${targetUserId}`, {}, {}, false)
      return response
    } catch (err) {
      console.error(err)
      throw err
    }
  }
  const {
    data: userResponse,
    isFetching,
    error,
  } = useQuery<UserResponse>({
    queryKey: ['userInfo', targetUserId],
    queryFn: fetchUserInfo,
    enabled: !!targetUserId,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  })
  // console.log('currentUser', currentUser)
  // 如果查询的是当前用户，则返回当前用户信息
  // if (queryUserId && queryUserId === currentUser?.userId) {
  //   return {
  //     userInfo: currentUser,
  //     loading: false,
  //     error: null,
  //   }
  // }

  useEffect(() => {
    if (error) {
      showToast.error(t`Cannot reach the server.`)
      console.error(error)
    }
  }, [error])

  return {
    userInfo: userResponse?.user,
    loading: isFetching,
    error,
    topSkins: userResponse?.topSkins,
  }
}
